<mat-drawer-container class="dataspace-workspace-shell" autosize>
  <mat-drawer
    [opened]="helpPanelOpened"
    mode="side"
    position="end"
    class="dataspace-help-drawer">
    <div class="dataspace-help-drawer__header">
      <div>
        <div class="dataspace-help-drawer__eyebrow">Info</div>
        <h2>Nutzungsmodell im Überblick</h2>
        <p>Die Erklärungen bleiben verfügbar, stören aber nicht mehr den eigentlichen Arbeitsbereich.</p>
      </div>
      <button mat-icon-button type="button" (click)="helpPanelOpened = false">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="dataspace-help-drawer__content">
      <div class="dataspace-help-drawer__actions" *ngIf="isPlatformAdmin">
        <button
          mat-stroked-button
          type="button"
          class="dataspace-seed-button"
          [disabled]="!activeOrganisationId || demoSeedBusy || runtimeCleanupBusy"
          (click)="seedDemoData()">
          Demo Seed
        </button>
        <button
          mat-stroked-button
          color="warn"
          type="button"
          class="dataspace-seed-button"
          [disabled]="!activeOrganisationId || demoSeedBusy || runtimeCleanupBusy"
          (click)="cleanupRuntimeData()">
          Datenbank bereinigen
        </button>
      </div>

      <article class="dataspace-help-card">
        <mat-icon>fact_check</mat-icon>
        <div>
          <strong>Struktur statt PDF-Chaos</strong>
          <span>Freigaben und Inhalte sind je Bericht nachvollziehbar gegliedert.</span>
        </div>
      </article>
      <article class="dataspace-help-card">
        <mat-icon>swap_horiz</mat-icon>
        <div>
          <strong>Kontrollierte Übergabe</strong>
          <span>NU Organisationen teilen gezielt mit ausgewählten GU Empfängern.</span>
        </div>
      </article>
      <article class="dataspace-help-card">
        <mat-icon>lan</mat-icon>
        <div>
          <strong>Überblick über mehrere NU</strong>
          <span>GU sehen eingehende Berichte projektbezogen an einer Stelle.</span>
        </div>
      </article>
    </div>
  </mat-drawer>

  <mat-drawer-content>
  <section class="dataspace-workspace-page" [class.is-nu]="perspective === 'nu'" [class.is-connector]="perspective === 'connector'" [class.is-gu]="perspective === 'gu'">
    <header class="dataspace-role-shell">
      <div class="dataspace-role-shell__topline">
        <div class="dataspace-page-header__eyebrow">Bautagebuch <span>/</span> Live Workspace</div>
        <div class="dataspace-role-shell__topline-actions">
          <div class="dataspace-topline-org-hint" *ngIf="!activeOrganisationId && !initializing">
            Bitte wählen Sie hier eine Organisation aus ->
          </div>

          <mat-form-field appearance="outline" class="dataspace-topline-org-select">
            <mat-label>Organisation</mat-label>
            <mat-select [(ngModel)]="selectedOrganisationId" (selectionChange)="activateSelectedOrganisation()">
              <mat-option *ngFor="let membership of sortedMemberships" [value]="membership.organisationId">
                {{ membership.organisationName || membership.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <button mat-icon-button type="button" class="dataspace-help-trigger" aria-label="Nutzungsmodell" (click)="helpPanelOpened = !helpPanelOpened">
            <mat-icon>info</mat-icon>
          </button>
        </div>
      </div>

      <section class="dataspace-role-switch" aria-label="Perspektive umschalten">
        <button
          type="button"
          class="dataspace-role-switch__option dataspace-role-switch__option--nu"
          [class.is-active]="perspective === 'nu'"
          (click)="setPerspective('nu')">
          <div class="dataspace-role-switch__content">
            <div class="dataspace-role-switch__title">
              <span class="dataspace-role-switch__label">1</span>
              <strong>Datenanbieter</strong>
            </div>
          </div>
        </button>
        <button
          type="button"
          class="dataspace-role-switch__option dataspace-role-switch__option--connector"
          [class.is-active]="perspective === 'connector'"
          (click)="setPerspective('connector')">
          <div class="dataspace-role-switch__content">
            <div class="dataspace-role-switch__title">
              <span class="dataspace-role-switch__label">2</span>
              <strong>Connector</strong>
            </div>
          </div>
        </button>
        <button
          type="button"
          class="dataspace-role-switch__option dataspace-role-switch__option--gu"
          [class.is-active]="perspective === 'gu'"
          (click)="setPerspective('gu')">
          <div class="dataspace-role-switch__content">
            <div class="dataspace-role-switch__title">
              <span class="dataspace-role-switch__label">3</span>
              <strong>Datennutzer</strong>
            </div>
          </div>
        </button>
      </section>
    </header>

    <app-connector-control-plane
      [class.dataspace-view-hidden]="perspective !== 'connector'"
      [organisationId]="activeOrganisationId"
      [refreshNonce]="workspaceRefreshNonce">
    </app-connector-control-plane>

    <app-dataspace-nu-reports-view
      [class.dataspace-view-hidden]="perspective !== 'nu'"
      [organisationId]="activeOrganisationId"
      [organisationName]="activeOrganisationName"
      [memberships]="memberships"
      [refreshNonce]="workspaceRefreshNonce">
    </app-dataspace-nu-reports-view>

    <app-dataspace-gu-inbox-view
      [class.dataspace-view-hidden]="perspective !== 'gu'"
      [organisationId]="activeOrganisationId"
      [organisationName]="activeOrganisationName"
      [refreshNonce]="workspaceRefreshNonce">
    </app-dataspace-gu-inbox-view>
  </section>
  </mat-drawer-content>
</mat-drawer-container>
